'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _Link = require('react-router/lib/Link');

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./DetailsLink.scss');

var DetailsLink = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(DetailsLink, _PureComponent);

  function DetailsLink() {
    (0, _classCallCheck3.default)(this, DetailsLink);
    return (0, _possibleConstructorReturn3.default)(this, (DetailsLink.__proto__ || (0, _getPrototypeOf2.default)(DetailsLink)).apply(this, arguments));
  }

  (0, _createClass3.default)(DetailsLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          to = _props.to,
          title = _props.title,
          onClick = _props.onClick;

      var rootClass = (0, _bind2.default)(styles.link, className);
      var titleEl = _react2.default.createElement(
        'span',
        { className: styles.title },
        title
      );

      return onClick ? _react2.default.createElement(
        'a',
        { className: rootClass, onClick: onClick },
        titleEl,
        ' >'
      ) : _react2.default.createElement(
        _Link2.default,
        { className: rootClass, to: to },
        titleEl,
        ' >'
      );
    }
  }]);
  return DetailsLink;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  title: _propTypes2.default.string,
  to: _propTypes2.default.string.isRequired
}, _class.defaultProps = {
  onClick: null,
  title: ''
}, _temp);
exports.default = DetailsLink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DetailsLink/DetailsLink.js
// module id = 1986
// module chunks = 1